import { FormType } from 'generated/graphql';
import { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import Button from '../../../../components/atoms/Button/Button';
import CompanySelectFormField from '../../../../components/molecules/SelectFormField/CompanySelectFormField/CompanySelectFormField';
import SelectFormField from '../../../../components/molecules/SelectFormField/SelectFormField';
import SwitchFormField from '../../../../components/molecules/SwitchFormField/SwitchFormField';
import { ModalTypes } from '../../../../enums/modalTypes';
import { openModal } from '../../../../graphql/modals';
import { TSelectFormFieldValue } from '../../../../interfaces/forms/form';

interface ICompanyRequirementsHeader {
  isArchivedVisible: boolean;
  companyIdFilter: string;
  formFilter: FormType;
  onToggleIsArchivedVisibility: () => void;
  onChangeCompanyIdFilter: (
    companyId: TSelectFormFieldValue,
    name: string
  ) => void;
  onFormFilterChange: (
    newFormFilter: TSelectFormFieldValue,
    name: string
  ) => void;
}

const formFilterOptions = [
  {
    label: 'Candidate Information',
    value: FormType.CiForm,
  },
  {
    label: 'Candidate Diversity',
    value: FormType.CdForm,
  },
  {
    label: 'Talent Review',
    value: FormType.TrForm,
  },
  {
    label: 'Reskilling',
    value: FormType.RsForm,
  },
  {
    label: 'Apprentice',
    value: FormType.ApprenticeForm,
  },
  {
    label: 'Grad',
    value: FormType.GradForm,
  },
  {
    label: 'Undergrad',
    value: FormType.UndergradForm,
  },
  {
    label: 'AWE Apprentice',
    value: FormType.AweApprenticeForm,
  },
  {
    label: 'AWE Undergrads/Evolve/DSUS',
    value: FormType.AweDsus,
  },
];

const CompanyRequirementsHeader: FC<ICompanyRequirementsHeader> = ({
  isArchivedVisible,
  companyIdFilter,
  formFilter,
  onFormFilterChange,
  onToggleIsArchivedVisibility,
  onChangeCompanyIdFilter,
}) => {
  const handleOpenCreateCandidateInfoFieldModal = () => {
    openModal(ModalTypes.CANDIDATE_INFO_FIELD_MODAL, {
      companyId: +companyIdFilter,
      formFilter,
    });
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid
        container
        direction="row"
        xs={6}
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h5">Company requirements</Typography>
        </Grid>
        <Grid item xs={5}>
          <CompanySelectFormField
            id="crh-company"
            name="companyId"
            label="Company"
            value={companyIdFilter}
            onChange={onChangeCompanyIdFilter}
          />
        </Grid>
        <Grid item>
          <SelectFormField
            id="crh-form"
            name="form"
            label="Form"
            value={formFilter}
            onChange={onFormFilterChange}
            options={formFilterOptions}
            hasNullValue={false}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        xs={6}
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item>
          <SwitchFormField
            id="toggle-displey-archived-form-fields"
            name="isArchivedVisible"
            color="primary"
            value={isArchivedVisible}
            label="display / hide archived fields"
            onChange={onToggleIsArchivedVisibility}
          />
        </Grid>
        <Grid item>
          <Button
            onClick={handleOpenCreateCandidateInfoFieldModal}
            color="inherit"
          >
            Add new
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CompanyRequirementsHeader;
